// @ts-nocheck
/* Joypadia — CVR 24/10 : prix réels dans les tableaux comparatifs des articles.
   Chaque tableau du corps qui cite des fiches produit reçoit, à côté du nom, le prix
   courant lu sur /products/<handle>.js (devise et langue du visiteur). Rien n'est écrit
   dans le HTML serveur : le texte indexé de l'article ne change pas.
   ponytail: un fetch par produit distinct, chargé quand le tableau approche de l'écran ;
   passer par la Storefront API en lot si un tableau dépasse ~40 produits. */
(function () {
  const seen = new Map();
  const from = (document.currentScript && document.currentScript.dataset.from) || '';
  const fmt = c => (window.PR && PR.formatMoney) ? PR.formatMoney(c) : (c / 100).toFixed(2).replace('.', ',') + ' €';
  const get = url => {
    if (!seen.has(url)) seen.set(url, fetch(url + '.js').then(r => r.ok ? r.json() : null).catch(() => null));
    return seen.get(url);
  };
  function fill(table) {
    table.querySelectorAll('tr').forEach(tr => {
      const a = tr.querySelector('a[href*="/products/"]');
      if (!a || a.parentNode.querySelector('.pr-tprice')) return;
      const url = a.pathname.replace(/\/$/, '');
      get(url).then(p => {
        if (!p || !p.available) return;
        const s = document.createElement('span');
        s.className = 'pr-tprice';
        s.textContent = (p.price_varies && from ? from + ' ' : '') + fmt(p.price_min);
        a.after(s);
      });
    });
  }
  const tables = [...document.querySelectorAll('.prose table')].filter(t => t.querySelector('a[href*="/products/"]'));
  if (!tables.length) return;
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { fill(e.target); io.unobserve(e.target); } }), { rootMargin: '400px' });
  tables.forEach(t => io.observe(t));
})();
